import { MainBtn } from 'components/Buttons';
import styled from 'styled-components';

export const SignupContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(122deg, rgb(235 161 198 / 58%) 0%, #fff6fb 40%);
`;

export const FormContainer = styled.div`
  width: 90%;
  max-width: 800px;
  margin: 90px auto;
  background-color: #fff;
  border-radius: 15px;
  padding: 60px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    margin-top: 60px;
    margin-bottom: 60px;
    padding: 40px 20px;
  }

  .logo-wrapper {
    text-align: center;

    img {
      width: 230px;
    }
  }

  .title {
    margin-top: 28px;
    margin-bottom: 60px;
    color: var(--primary-color);
    text-align: center;

    .btn-login-xl {
      display: flex;
      column-gap: 10px;
      margin-top: 20px;

      button {
        height: 40px;
        width: 50px;
        border-style: none;
        border-radius: 20px;
      }

      @media (max-width: 768px) {
        display: none;
      }

      img {
        cursor: pointer;
      }

      .facebook-btn-xl {
        width: auto;
      }

      .google-btn-xl {
        background-color: transparent !important;
        display: block !important;
        align-items: unset !important;
        color: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
        border-radius: 2px !important;
        border: none !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        font-family: inherit !important;
        opacity: 1 !important;
      }
    }

    .btn-login-sm {
      display: none;
      row-gap: 20px;
      margin-top: 20px;
      flex-direction: column;

      @media (max-width: 768px) {
        display: flex;
      }

      .facebook-btn-sm {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        background-color: #3b5998;
        height: 42px;
        font-family: 'Inter ExtraBold';
        border-radius: 20px;
        border-style: none;
        width: 100%;
        color: white;
      }

      .google-btn-sm {
        display: flex;
        align-items: center;
        height: 42px;
        justify-content: center;
        color: var(--third-color);
        font-family: 'Inter ExtraBold';
        background-color: white;
        border: 1.7px solid rgba(155, 153, 175, 0.31);
        border-radius: 20px;

        img {
          margin-right: 15px;
        }
      }
    }

    h2 {
      font-size: var(--font-larger);
      font-weight: normal;
    }

    h4 {
      margin-top: 18px;
    }
  }

  .form-footer {
    margin-top: 50px;

    p {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 15px;
      cursor: pointer;
    }
  }
`;

export const SocialMediaLinks = styled.div`
  display: flex;
  gap: 18px;
`;

export const SocialMedia = styled.div``;

export const SignupMainButton = styled(MainBtn)`
  width: 100%;
  height: 60px;
  font-weight: bold;
  font-size: var(--font-medium);

  .icon {
    width: 12px;
  }
`;
